import {Components, Theme} from '@mui/material/styles';

const Link = (theme: Theme): {MuiLink: Components['MuiLink']} => {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'none',
      },
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,

          '&:hover': {
            color: theme.palette.primary.main,
          },
        },
      },
    },
  };
};

export default Link;
